var _ellipse, _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.0894,
    cy: 34.1421,
    rx: 20.5,
    ry: 5,
    fill: "url(#paint0_radial_2633_10728)",
    fillOpacity: 0.46
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2633_10728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.589355,
    y: 0.14209,
    width: 40.0966,
    height: 40.1099,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2633_10728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6376 12.6765C19.8301 12.6765 19.1409 12.391 18.5701 11.82C17.9993 11.249 17.7139 10.5596 17.7139 9.75183C17.7139 8.94406 17.9993 8.25467 18.5701 7.68366C19.1409 7.11265 19.8301 6.82715 20.6376 6.82715C21.4451 6.82715 22.1342 7.11265 22.705 7.68366C23.2759 8.25467 23.5613 8.94406 23.5613 9.75183C23.5613 10.5596 23.2759 11.249 22.705 11.82C22.1342 12.391 21.4451 12.6765 20.6376 12.6765ZM17.2962 33.5671V25.2108H15.6255V17.6902C15.6255 16.7711 15.9527 15.9842 16.607 15.3296C17.2614 14.675 18.048 14.3478 18.9669 14.3478H22.3083C23.2271 14.3478 24.0138 14.675 24.6681 15.3296C25.3225 15.9842 25.6496 16.7711 25.6496 17.6902V25.2108H23.979V33.5671H17.2962Z",
    fill: "#FF6464"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2633_10728",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.0894 34.1421) rotate(90) scale(5 20.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B5B5B",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b09ffa08588c6230fc401b17d26266e8.svg";
export { ForwardRef as ReactComponent };